import { Icon } from '@/ui/icons/Icon';
import styles from './EmptyState.module.css';

interface EmptyStateProps {
  readonly title: string;
  readonly description?: string;
  readonly icon?: string;
}

/** Shared placeholder for panels without content. */
export function EmptyState({ title, description, icon = 'empty' }: EmptyStateProps) {
  return (
    <div className={styles.empty}>
      <span className={styles.icon}>
        <Icon name={icon} size={28} />
      </span>
      <p className={styles.title}>{title}</p>
      {description !== undefined && <p className={styles.description}>{description}</p>}
    </div>
  );
}
